import { render, staticRenderFns } from "./PageTour.vue?vue&type=template&id=7e5f23ba"
import script from "./PageTour.vue?vue&type=script&lang=js"
export * from "./PageTour.vue?vue&type=script&lang=js"
import style0 from "./PageTour.vue?vue&type=style&index=0&id=7e5f23ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports